import React from 'react';
import { FaEdit } from 'react-icons/fa';
import BaseModal from '../common/BaseModal';

const ManufacturerModal = ({
  show,
  onClose,
  selectedProducts,
  manufacturers,
  bulkManufacturerChange,
  setBulkManufacturerChange,
  onApply,
}) => {
  const footerButtons = (
    <>
      <button type="button" className="btn btn-secondary" onClick={onClose}>
        Anuluj
      </button>
      <button type="button" className="btn btn-primary" onClick={onApply} disabled={!bulkManufacturerChange}>
        <FaEdit className="me-1" />
        Zmień producenta
      </button>
    </>
  );

  return (
    <BaseModal
      isOpen={show}
      onClose={onClose}
      title={<><FaEdit className="me-2" />Zmiana producenta - {selectedProducts.size} produktów</>}
      size="md"
      footer={footerButtons}
    >
      <div className="mb-3">
        <label className="form-label">Wybierz producenta:</label>
        <select className="form-select"
          value={bulkManufacturerChange}
          onChange={(e) => setBulkManufacturerChange(e.target.value)}>
          <option value="">Wybierz producenta...</option>
          {manufacturers.map((manufacturer) => (
            <option key={manufacturer.id} value={manufacturer.id}>{manufacturer.nazwa}</option>
          ))}
        </select>
      </div>
      <div className="alert alert-info">
        <small>
          Zaznaczone produkty: {selectedProducts.size}<br/>
          Operacja zmieni producenta dla wszystkich zaznaczonych produktów.
        </small>
      </div>
    </BaseModal>
  );
};

export default ManufacturerModal;
